import axios from "axios";

var downloadFile = function downloadFile(url, fileName) {
  axios({
    url: url,
    method: "GET",
    responseType: "blob"
  }).then(function (response) {
    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
    var fileLink = document.createElement("a");
    fileLink.href = fileURL;
    fileLink.setAttribute("download", fileName);
    document.body.appendChild(fileLink);
    fileLink.click();
    document.body.removeChild(fileLink);
    window.URL.revokeObjectURL(fileURL);
  });
};

export { downloadFile };